// @core/api/endpoints/document/get_document.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Get document
 * Retrieves a standalone document with metadata, current version info, review status, and linked resources.
 */
export async function GetDocument(
  document_id: string,
  options?: RequestOptions
): Promise<DocumentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:document_id`;
  requestPath = requestPath.replace(':document_id', encodeURIComponent(document_id));
  const requestOptions = options;
  return client.get<DocumentResponse>(requestPath, { ...requestOptions });
}
